import { render, staticRenderFns } from "./DashPeriodFilter.vue?vue&type=template&id=4cca9c95"
import script from "./DashPeriodFilter.vue?vue&type=script&lang=js"
export * from "./DashPeriodFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports